/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { OrbitAddressRegistry } from "../OrbitAddressRegistry";

export class OrbitAddressRegistry__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<OrbitAddressRegistry> {
    return super.deploy(overrides || {}) as Promise<OrbitAddressRegistry>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): OrbitAddressRegistry {
    return super.attach(address) as OrbitAddressRegistry;
  }
  connect(signer: Signer): OrbitAddressRegistry__factory {
    return super.connect(signer) as OrbitAddressRegistry__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): OrbitAddressRegistry {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as OrbitAddressRegistry;
  }
}

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "collectionRegistry",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "marketplace",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "orbitRewardsDistributor",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "orbitalApes",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "tokenRegistry",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_collectionRegistry",
        type: "address",
      },
    ],
    name: "updateCollectionRegistry",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_marketplace",
        type: "address",
      },
    ],
    name: "updateMarketplace",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_orbitRewardsDistributor",
        type: "address",
      },
    ],
    name: "updateOrbitRewardsDistributor",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_orbitalApes",
        type: "address",
      },
    ],
    name: "updateOrbitalApes",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_tokenRegistry",
        type: "address",
      },
    ],
    name: "updateTokenRegistry",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_wEVMOS",
        type: "address",
      },
    ],
    name: "updateWEVMOS",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "wEVMOS",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";
